import { Skeleton, Row, Col, Space } from "antd";
import {
	Inner,
	ProductData,
	PublishContainer,
	PublishSettings,
} from "./styles";

const GUTTER = 10;

export default function LoadingSkeleton() {
	return (
		<Inner>
			<ProductData>
				<Space direction="vertical" size="middle" style={{ display: "flex" }}>
					<Row></Row>
					<Row gutter={GUTTER}>
						<Col span={22}>
							<Skeleton.Input active={true} block />
						</Col>
					</Row>
					<Row></Row>
					<Row></Row>
					<Row gutter={GUTTER}>
						<Col span={22}>
							<Skeleton.Input active={true} block />
						</Col>
					</Row>
					<Row></Row>
					<Row></Row>
					<Row gutter={GUTTER}>
						<Col span={22}>
							<Skeleton.Input active={true} block />
						</Col>
					</Row>
					<Row></Row>
					<Row></Row>
					<Row gutter={GUTTER}>
						<Col span={14}>
							<Skeleton.Input active={true} block />
						</Col>
					</Row>
					<Row></Row>
					<Row></Row>
					<Row gutter={GUTTER}>
						<Col span={14}>
							<Skeleton.Input active={true} block />
						</Col>
					</Row>
					<Row></Row>
					<Row></Row>
					<Row gutter={GUTTER}>
						<Col span={14}>
							<Skeleton.Input active={true} block />
						</Col>
					</Row>
					<Row></Row>
					<Row></Row>
					<Row gutter={GUTTER}>
						<Col span={8}>
							<Skeleton.Input active={true} block />
						</Col>
					</Row>
					<Row></Row>
					<Row></Row>
					<Row gutter={GUTTER}>
						<Col span={14}>
							<Skeleton.Input active={true} block />
						</Col>
					</Row>
					<Row></Row>
					<Row></Row>
					<Row gutter={GUTTER}>
						<Col span={22}>
							<Skeleton.Input active={true} block />
						</Col>
					</Row>
					<Row></Row>
					<Row></Row>
					<Row gutter={GUTTER}>
						<Col span={22}>
							<Skeleton.Input active={true} block />
						</Col>
					</Row>
					<Row></Row>
					<Row></Row>
					<Row gutter={GUTTER}>
						<Col span={4}>
							<Skeleton.Input active={true} block />
						</Col>
					</Row>
					<Row gutter={GUTTER}>
						<Col span={8}>
							<Skeleton.Image active={true} block />
						</Col>
					</Row>
					<Row></Row>
					<Row></Row>
					<Row gutter={GUTTER}>
						<Col span={8}>
							<Skeleton.Input active={true} block />
						</Col>
					</Row>
					<Row></Row>
					<Row></Row>
					<Row gutter={GUTTER}>
						<Col span={8}>
							<Skeleton.Input active={true} block />
						</Col>
					</Row>
					<Row></Row>
					<Row></Row>
					<Row gutter={GUTTER}>
						<Col span={8}>
							<Skeleton.Input active={true} block />
						</Col>
					</Row>
					<Skeleton
						active
						size="default"
						paragraph={{
							rows: 8,
						}}
						style={{ width: "60%" }}
					/>
					<Row></Row>
					<Row></Row>
					<Row gutter={GUTTER}>
						<Col span={22}>
							<Skeleton.Input active={true} block />
						</Col>
					</Row>
					<Row></Row>
				</Space>
			</ProductData>

			<PublishSettings>
				<Space direction="vertical" size="middle" style={{ display: "flex" }}>
					<PublishContainer>
						<Row gutter={GUTTER}>
							<Col span={12}>
								<Skeleton.Input
									active={true}
									size="default"
									style={{
										marginTop: "60px",
										width: "350px",
										marginLeft: "20px",
									}}
								/>
							</Col>
						</Row>
						<Row></Row>
						<Row></Row>
						<Row gutter={GUTTER}>
							<Col span={10}>
								<Skeleton.Input
									active={true}
									size="default"
									style={{
										marginTop: "50px",
										width: "350px",
										marginLeft: "20px",
									}}
								/>
							</Col>
						</Row>
						<Row></Row>
						<Row></Row>
						<Row gutter={GUTTER}>
							<Col span={10}>
								<Skeleton.Input
									active={true}
									size="default"
									style={{
										marginTop: "130px",
										width: "350px",
										marginLeft: "20px",
									}}
								/>
							</Col>
						</Row>
						<Row></Row>
						<Row></Row>
						<Row gutter={GUTTER}>
							<Col span={10}>
								<Skeleton.Input
									active={true}
									size="large"
									style={{
										marginTop: "50px",
										width: "350px",
										marginLeft: "20px",
									}}
								/>
							</Col>
						</Row>
					</PublishContainer>
				</Space>
			</PublishSettings>
		</Inner>
	);
}
